import { lzIsArray } from "../services/LzType";
import WarningIcon from '@material-ui/icons/Warning';
import PdfSvgIcon from '../components/commons/svg-icons/pdf';
import MsExcelSvgIcon from '../components/commons/svg-icons/ms-excel';
import CsvSvgIcon from '../components/commons/svg-icons/csv';
import TxtSvgIcon from '../components/commons/svg-icons/txt';
import HtmlSvgIcon from '../components/commons/svg-icons/html';
import LzOptionModel from "./option";

export default class MediaModel {

  /**
   * File Types to be defined here.
   * NOTE: if adding another type, do add corresponding ACCEPT_xxx and also edit getFileTypeOptions() below.
   */
  static FILE_TYPE_IMAGE = 1;
  static FILE_TYPE_DOCUMENT = 2;

  static CONTENT_TYPE_ALL_TEXT = 'text/*';
  static CONTENT_TYPE_CSV = 'text/csv';
  static CONTENT_TYPE_ALL_IMAGES = 'image/*';
  static CONTENT_TYPE_JSON = 'application/json';
  static CONTENT_TYPE_PDF = 'application/pdf';
  static CONTENT_TYPE_ALL_AUDIO = 'audio/*';
  static CONTENT_TYPE_ALL_VIDEO = 'video/*';

  static ACCEPT_DOCUMENTS = ['text/*', 'image/*', 'application/pdf', 'application/json', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  static ACCEPT_IMAGES = ['image/*'];

  static CONTENT_TYPE_ICONS = {
    '': <WarningIcon style={{ width: '100%', height: '100%' }} />,
    'application/pdf': <PdfSvgIcon style={{ width: '100%', height: '100%' }} />,
    'application/vnd.ms-excel': <MsExcelSvgIcon style={{ width: '100%', height: '100%' }} />,
    'text/csv': <CsvSvgIcon style={{ width: '100%', height: '100%' }} />,
    'text/plain': <TxtSvgIcon style={{ width: '100%', height: '100%' }} />,
    'text/html': <HtmlSvgIcon style={{ width: '100%', height: '100%' }} />,
  };

  constructor(model) {
    if (!model) {
      model = {};
    }

    this.id = model.id ? +model.id : 0;
    this.category = model.category ? model.category : '';
    this.name = model.name ? model.name : '';
    this.file_name = model.file_name ? model.file_name : '';
    this.file_size = model.file_size ? +model.file_size : 0;
    this.file_path = model.file_path ? model.file_path : '';
    this.file_preview_path = model.file_preview_path ? model.file_preview_path : '';
    this.file_type = model.file_type ? +model.file_type : MediaModel.FILE_TYPE_IMAGE;
    this.content_type = model.content_type ? model.content_type : '';
    this.is_private = !!model.is_private;
    this.is_active = typeof model.is_active === 'undefined' ? true : !!model.is_active;
    this.created_at = model.created_at ? model.created_at : '';
    this.updated_at = model.updated_at ? model.updated_at : '';
    this.deleted_at = model.deleted_at ? model.deleted_at : '';
  }

  static parseArray(data) {
    if (!lzIsArray(data)) {
      return [];
    }

    const out = [];
    for (const item of data) {
      out.push(new MediaModel(item));
    }

    return out;
  }

  /**
   * Get image icon representation based on the given file object.
   * 
   * @param {*} file 
   * 
   * @returns 
   */
  static getImageIconByFile(file) {
    // If file object given is not readable or type not existing
    if (!file && typeof file.name === 'undefined') {
      return MediaModel.CONTENT_TYPE_ICONS[''];
    }

    // If file type is empty (in many cases, file type is not recognized even though it is a common file type)
    if ('' === file.type) {
      if (file.name.indexOf('.csv') > 0) {
        return MediaModel.CONTENT_TYPE_ICONS['text/csv'];
      }
    }

    // If file is an image
    if (MediaModel.isImageByContentType(file.type)) {
      return MediaModel.getImageUrlFromFile(file);
    }

    // If type is specified and its not an image then it comes here, so return icon by type
    return MediaModel.getIconByContentType(file.type);
  }

  static isImageByContentType(contentType) {
    return 0 === contentType.indexOf('image/');
  }

  static getIconByContentType(contentType) {
    return MediaModel.CONTENT_TYPE_ICONS[contentType] || MediaModel.CONTENT_TYPE_ICONS[''];
  }

  /**
   * Get image url from the html file object.
   *
   * @param {*} file Html file object.
   */
  static getImageUrlFromFile(file) {
    return URL.createObjectURL(file);
  }

  static getContentTypeFromParams(contentType, fileType) {
    if (contentType && '' !== contentType) {
      return contentType;
    }

    return fileType === MediaModel.FILE_TYPE_IMAGE ? MediaModel.ACCEPT_IMAGES : MediaModel.ACCEPT_DOCUMENTS;
  }

  static getFileTypeOptions() {
    return [
      new LzOptionModel({ value: MediaModel.FILE_TYPE_IMAGE, text: 'Image' }),
      new LzOptionModel({ value: MediaModel.FILE_TYPE_DOCUMENT, text: 'Document' }),
    ];
  }

  get isImage() {
    return this.file_type === MediaModel.FILE_TYPE_IMAGE;
  }

  get contentTypeIcon() {
    return MediaModel.getIconByContentType(this.content_type);
  }

}
